import type { AdminUser, User } from 'app/typings';
import { UserRole } from 'app/typings';

export const isUserSuperAdmin = (user?: AdminUser | User) => {
  return user?.role === UserRole.SuperAdmin;
};
